import { withinPrefix } from '@/components/layout/use-active-section'

/**
 * True on `/portfolio` and every Portfolio page under it, where the mock draws the Portfolio rail
 * (What's happening · Reminders · Portfolio health) in place of the shared Market rail. The import
 * and Mitra AI pages pass `fullWidth`, so they draw no rail track at all.
 */
export const isPortfolioRoute = (pathname: string): boolean => withinPrefix(pathname, '/portfolio')
